// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css */

.breadcrumb-link {
  color: #475467;
  text-decoration: none;
  transition: background-color 0.3s, color 0.3s;
  padding: 4px 8px;
  border-radius: 4px;
}

.breadcrumb-link:hover {
  background-color: #0C66E4; /* Purple background */
  color: #ffffff;            /* White text */
}
/* .sticky-clear-row td {
  position: sticky;
  left: 0;
  background: #f0f7ff;
  z-index: 2;
  font-weight: 600;
} */

.sticky-bhel-row td {
  position: sticky;
  left: 0;
  background: #e6f4ff;
  z-index: 2;
  font-weight: 700;
}

.summary-total-fixed {
  position: sticky !important;
  right: 0 !important;
  z-index: 20;
  background: #cce6ff !important;
}

.dm-group-heading-row td{
    background:#EEF4FB !important;
    font-weight:700;
}

.dm-group-total-row td{
    background:#FAF6E3 !important;
    font-weight:700;
}

.dm-grand-total-row td{
    background:#E8F4E1 !important;
    font-weight:700;
}

.dm-project-row td{
    background:#FFFFFF !important;
}
.dm-grand-total-row td{
    background:#D6E4FF !important;
    font-weight:800;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;EACE,cAAc;EACd,qBAAqB;EACrB,6CAA6C;EAC7C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,sBAAsB;EACjD,cAAc,aAAa,eAAe;AAC5C;AACA;;;;;;GAMG;;AAEH;EACE,gBAAgB;EAChB,OAAO;EACP,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;AACA;IACI,6BAA6B;IAC7B,eAAe;AACnB","sourcesContent":["/* styles.css */\n\n.breadcrumb-link {\n  color: #475467;\n  text-decoration: none;\n  transition: background-color 0.3s, color 0.3s;\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n.breadcrumb-link:hover {\n  background-color: #0C66E4; /* Purple background */\n  color: #ffffff;            /* White text */\n}\n/* .sticky-clear-row td {\n  position: sticky;\n  left: 0;\n  background: #f0f7ff;\n  z-index: 2;\n  font-weight: 600;\n} */\n\n.sticky-bhel-row td {\n  position: sticky;\n  left: 0;\n  background: #e6f4ff;\n  z-index: 2;\n  font-weight: 700;\n}\n\n.summary-total-fixed {\n  position: sticky !important;\n  right: 0 !important;\n  z-index: 20;\n  background: #cce6ff !important;\n}\n\n.dm-group-heading-row td{\n    background:#EEF4FB !important;\n    font-weight:700;\n}\n\n.dm-group-total-row td{\n    background:#FAF6E3 !important;\n    font-weight:700;\n}\n\n.dm-grand-total-row td{\n    background:#E8F4E1 !important;\n    font-weight:700;\n}\n\n.dm-project-row td{\n    background:#FFFFFF !important;\n}\n.dm-grand-total-row td{\n    background:#D6E4FF !important;\n    font-weight:800;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
